import { render, staticRenderFns } from "./CustomerServiceModal.vue?vue&type=template&id=aa81c718&scoped=true"
import script from "./CustomerServiceModal.vue?vue&type=script&lang=js"
export * from "./CustomerServiceModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceModal.vue?vue&type=style&index=0&id=aa81c718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa81c718",
  null
  
)

export default component.exports